"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.track = void 0;
const get_zaraz_1 = require("./helpers/get-zaraz");
function track(eventName, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
properties) {
    return (0, get_zaraz_1.getZaraz)().track(eventName, properties);
}
exports.track = track;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJhY2suanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvdHJhY2sudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsbURBQStDO0FBRS9DLFNBQWdCLEtBQUssQ0FDbkIsU0FBaUI7QUFDakIsOERBQThEO0FBQzlELFVBQWdDO0lBRWhDLE9BQU8sSUFBQSxvQkFBUSxHQUFFLENBQUMsS0FBSyxDQUFDLFNBQVMsRUFBRSxVQUFVLENBQUMsQ0FBQztBQUNqRCxDQUFDO0FBTkQsc0JBTUMifQ==